var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',_vm._b({staticClass:"c_asset_category_button",class:[`c_asset_button--${_vm.theme}`]},'Button',_vm.modifiedButtonOptions,false),[_c('span',[_vm._v("Data Sheet")])])
}
var staticRenderFns = []

export { render, staticRenderFns }